import { createContext } from 'react';
import type { ApiException } from '@/api/types';
import type { User, LoginCredentials } from '@/types/auth';

export interface AuthContextValue {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  isProfileLoading: boolean;
  profileError: ApiException | null;
  login: (credentials: LoginCredentials) => Promise<void>;
  logout: () => Promise<void>;
  refreshProfile: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
